<template>
  <div>
    <!-- ── Sticky Header ────────────────────────────────────── -->
    <header class="lp-v2-header" :class="{ 'lp-v2-header--scrolled': isScrolled }">
      <div class="lp-v2-header-container">
        <div class="lp-v2-header-wrap">
          <!-- Logo -->
          <a href="#" class="lp-v2-logo">
            <img
              v-if="landingPageData.picture_link"
              :src="landingPageData.picture_link"
              :alt="landingPageData.title"
              class="lp-v2-logo-img"
            />
          </a>

          <!-- Desktop Nav -->
          <nav class="lp-v2-nav d-none d-lg-flex">
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#our-clients">Our Partners</a></li>
              <li><a href="#map-home">Location</a></li>
              <li><a href="#testi">Testimonial</a></li>
            </ul>
          </nav>

          <div class="lp-v2-header-right">
            <a href="#contact" class="lp-v2-btn-contact">Contact Us</a>
            <button class="lp-v2-mobile-toggle d-lg-none" @click="mobileOpen = !mobileOpen">
              <span /><span /><span />
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile Menu -->
      <div v-show="mobileOpen" class="lp-v2-mobile-menu">
        <ul>
          <li><a href="#about" @click="mobileOpen = false">About</a></li>
          <li><a href="#services" @click="mobileOpen = false">Services</a></li>
          <li><a href="#our-clients" @click="mobileOpen = false">Our Partners</a></li>
          <li><a href="#map-home" @click="mobileOpen = false">Location</a></li>
          <li><a href="#testi" @click="mobileOpen = false">Testimonial</a></li>
          <li><a href="#contact" @click="mobileOpen = false">Contact Us</a></li>
        </ul>
      </div>
    </header>

    <!-- ── Hero Section ─────────────────────────────────────── -->
    <section class="lp-v2-hero">
      <div class="lp-v2-hero-bg" :style="heroBgStyle" />
      <div class="lp-v2-hero-overlay" />
      <div class="lp-v2-hero-content">
        <div class="lp-v2-hero-inner">
          <h1 class="lp-v2-hero-title">{{ landingPageData.title }}</h1>
          <p class="lp-v2-hero-desc">{{ landingPageData.description }}</p>
          <a href="#contact" class="lp-v2-hero-btn">Contact Us</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    landingPageData: { type: Object, required: true },
  },
  data() {
    return {
      isScrolled: false,
      mobileOpen: false,
    }
  },
  computed: {
    heroBgStyle() {
      const url = this.landingPageData.picture_hero_link
      return url
        ? { backgroundImage: `url(${url})` }
        : { backgroundColor: '#1a1a2e' }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 50
    },
  },
}
</script>

<style lang="scss" scoped>
/* ── Header ─────────────────────────────────────────────── */
.lp-v2-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  transition: background 0.4s ease-in-out, box-shadow 0.4s ease-in-out, border-color 0.4s;

  &--scrolled {
    background: #fff;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.12);
    border-bottom-color: rgba(0, 0, 0, 0.06);

    .lp-v2-nav ul li a {
      color: #1a1a2e;
      &:hover { color: #1675bc; }
    }
    .lp-v2-logo-img { filter: none; }
    .lp-v2-btn-contact {
      background: #1675bc;
      color: #fff;
      &:hover { background: darken(#1675bc, 8%); }
    }
    .lp-v2-mobile-toggle span { background: #1a1a2e; }
  }
}

.lp-v2-header-container {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.lp-v2-header-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.lp-v2-logo { display: flex; align-items: center; }

.lp-v2-logo-img {
  height: 52px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transition: filter 0.4s;

  @media (max-width: 767px) { height: 38px; }
}

.lp-v2-nav ul {
  display: flex;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;

  li a {
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    font-weight: 500;
    text-decoration: none;
    letter-spacing: 0.02em;
    transition: color 0.2s;
    &:hover { color: #fff; }
  }
}

.lp-v2-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.lp-v2-btn-contact {
  background: #fff;
  color: #1a1a2e;
  padding: 0.5rem 1.4rem;
  border-radius: 200px;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 0.02em;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: #f0f0f0;
    color: #1a1a2e;
    text-decoration: none;
  }
}

.lp-v2-mobile-toggle {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 6px;

  span {
    display: block;
    width: 24px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
    transition: background 0.3s;
  }
}

.lp-v2-mobile-menu {
  background: #0d1b35;
  padding: 1rem 1.5rem 1.5rem;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    li a {
      color: rgba(255, 255, 255, 0.85);
      font-size: 1rem;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0;
      border-bottom: 1px solid rgba(255,255,255,0.07);
      transition: color 0.2s;
      &:hover { color: #fff; }
    }

    li:last-child a { border-bottom: none; }
  }
}

/* ── Hero ────────────────────────────────────────────────── */
.lp-v2-hero {
  position: relative;
  height: 100vh;
  min-height: 550px;
  overflow: hidden;

  @media (max-width: 991px) { height: 80vh; }
  @media (max-width: 767px) { height: 70vh; min-height: 480px; }
}

.lp-v2-hero-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.lp-v2-hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(7, 9, 63, 0.58);
}

.lp-v2-hero-content {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 6rem;
  z-index: 2;

  @media (max-width: 767px) { padding-bottom: 3rem; align-items: center; }
}

.lp-v2-hero-inner {
  max-width: 1320px;
  width: 100%;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.lp-v2-hero-title {
  font-size: clamp(2rem, 4.5vw, 5rem);
  font-weight: 500;
  color: #fff;
  line-height: 1.15;
  margin-bottom: 1.25rem;
  max-width: 55%;

  @media (max-width: 991px) { max-width: 70%; }
  @media (max-width: 767px) { max-width: 100%; font-size: clamp(1.75rem, 6vw, 2.5rem); }
}

.lp-v2-hero-desc {
  font-size: clamp(0.95rem, 1.5vw, 1.1rem);
  color: rgba(255, 255, 255, 0.85);
  max-width: 40%;
  line-height: 1.7;
  margin-bottom: 2.25rem;

  @media (max-width: 991px) { max-width: 60%; }
  @media (max-width: 767px) { max-width: 100%; }
}

.lp-v2-hero-btn {
  display: inline-block;
  background: #fff;
  color: #1a1a2e;
  padding: 0.75rem 2.25rem;
  border-radius: 200px;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.03em;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    color: #1a1a2e;
    text-decoration: none;
  }
}
</style>
